import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export async function login(username, password) {
  const { data } = await apiClient.post("/auth/login", { username, password });
  return data;
}

export async function logout() {
  await apiClient.post("/auth/logout");
}

export async function me() {
  const { data } = await apiClient.get("/auth/me");
  return data;
}

export async function getIngestStatus() {
  const { data } = await apiClient.get("/ingest/status");
  return data;
}

export async function startIngest() {
  const { data } = await apiClient.post("/ingest/start");
  return data;
}

export async function searchHospitals(q, limit = 20) {
  const { data } = await apiClient.get("/hospitals/search", { params: { q, limit } });
  return data;
}

export async function getHospital(ccn) {
  const { data } = await apiClient.get(`/hospitals/${ccn}`);
  return data;
}

export async function getIndicators(ccn) {
  const { data } = await apiClient.get(`/hospitals/${ccn}/indicators`);
  return data;
}

export function scorecardUrl(ccn) {
  return `${API}/hospitals/${ccn}/scorecard.pdf`;
}

export async function filterHospitals(params) {
  const { data } = await apiClient.get("/hospitals/filter", { params });
  return data;
}

export async function listSystems() {
  const { data } = await apiClient.get("/systems");
  return data;
}

export async function getTelemetry() {
  const { data } = await apiClient.get("/admin/telemetry/llm");
  return data;
}
